export default __webpack_public_path__ + "static/media/mail.1d12d64c.svg";